import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import AuthForm from './AuthForm';
import './AuthForm.css';
import { AuthProvider, useAuth } from './AuthContext';
import AdminLayout from './components/AdminLayout';
import AdminDashboard from './components/AdminDashboard';
import UserManagement from './components/UserManagement';
import UserDetail from './components/UserDetail';
import UserChatHistory from './components/UserChatHistory';
import MobileConversationList from './components/MobileConversationList';
import MobileConversationViewer from './components/MobileConversationViewer';
import Analytics from './components/Analytics';
import SystemHealth from './components/SystemHealth';
import DynamoDBStats from './components/DynamoDBStats';
import CSSParticles from './components/CSSParticles';

import ChatApp from './ChatApp';
import './components/AdminComponents.css';

// Component to handle authentication check and routing
const AppContent = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="App">
        <div className="loading-screen">
          <h1>🎓 Practicum</h1>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="App">
        <CSSParticles />
        <div className="app-content">
          <AuthForm />
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<ChatApp />} />
      {/* Mobile admin routes - outside AdminLayout for full-screen experience */}
      <Route path="/admin/users/:userId/conversations" element={<MobileConversationList />} />
      <Route path="/admin/users/:userId/conversation/:conversationId" element={<MobileConversationViewer />} />
      
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="users" element={<UserManagement />} />
        <Route path="users/:userId" element={<UserDetail />} />
        <Route path="users/:userId/chats/:conversationId" element={<UserChatHistory />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="system-health" element={<SystemHealth />} />
        <Route path="dynamodb-stats" element={<DynamoDBStats />} />

      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <CSSParticles />
        <div className="app-content">
          <AppContent />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;